<script lang="ts">
  import RhythmSpan from 'exercises/src/uTheory.Notation/RhythmSpan.svelte';
  import { autorun, IReactionDisposer } from 'mobx';
  import type SectionKnowledgeTopicStore from 'shared/src/section/sectionKnowledge/section.knowledge.topic.store';
  import type { UserTopicStore } from 'shared/src/user/userKnowledge/user.topic.store';
  export let topic: SectionKnowledgeTopicStore | UserTopicStore;

  export let color: string | undefined = undefined;
  export let stroke: string | undefined = undefined;

  let title: string;
  let useRhythmTitle: boolean = false;
  let destroyer: IReactionDisposer;
  let meters: string[] = [];
  let titleWithoutMeter: string;

  const topicTitleMeterStrings = ['Simple Time:', 'Compound Time:', 'Cut Time:'] as const;

  $: {
    if (destroyer) destroyer();
    destroyer = autorun(() => {
      title = topic.title;
      titleWithoutMeter = topicTitleMeterStrings.reduce((t, s) => t.replace(s, ''), title);
      const rhythmType = topicTitleMeterStrings.find((s) => title.includes(s));
      useRhythmTitle = !!rhythmType;
      switch (rhythmType) {
        case 'Simple Time:':
          meters = ['2/4', '3/4', '4/4'];
          break;
        case 'Compound Time:':
          meters = ['6/8', '9/8', '12/8'];
          break;
        case 'Cut Time:':
          meters = ['2/2', '3/2', '4/2'];
          break;
        default:
          meters = [];
      }
    });
  }

  $: style = color ? `color: ${color}; ` : '';
</script>

<span {style}>
  {#if useRhythmTitle}
    <RhythmSpan timeSignatures={meters} {color} {stroke} />{titleWithoutMeter}
  {:else}
    {title}
  {/if}
</span>
